module.exports = __webpack_public_path__ + "static/media/home-ilustracao-profissional-saude.4d58b54f.png";